import * as React from "react";
function SvgCrossThick(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={5.29}
        d="M2.75 2.75l18.5 18.5m0-18.5l-18.5 18.5"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCrossThick);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
